var map = {
	"./level-1.svg": 3421,
	"./level-2.svg": 5598,
	"./level-3.svg": 8175,
	"./level-4.svg": 2288,
	"./level-5.svg": 4529,
	"./level-6.svg": 9490,
	"./level-li.svg": 5585,
	"./level1.svg": 7712,
	"./level10.svg": 5264,
	"./level11.svg": 1217,
	"./level12.svg": 850,
	"./level13.svg": 6019,
	"./level14.svg": 2124,
	"./level15.svg": 1069,
	"./level16.svg": 2718,
	"./level17.svg": 1151,
	"./level18.svg": 8264,
	"./level19.svg": 4886,
	"./level2.svg": 4755,
	"./level20.svg": 7305,
	"./level21.svg": 9384,
	"./level22.svg": 747,
	"./level3.svg": 114,
	"./level4.svg": 4045,
	"./level5.svg": 4572,
	"./level6.svg": 3599,
	"./level7.svg": 9870,
	"./level8.svg": 8745,
	"./level9.svg": 3352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4033;